/**
 * !!! AUTOGENERATED, DO NOT MODIFY !!!
 *
 * This file is generated by dashboard/script/remote_lookup/generate_remote_lookup_schemas.rb
 * Because the generation script depends on rails, generation is run manually and the file is checked in.
 * Please do not edit manually.
 *
 * To regenerate, run:
 *   yarn remote-lookup:update-generated-schemas
 *
 * @owner @Appboy/messaging-experience
 */

import { z } from "zod";
import { common } from "../common";

// Our zod-to-typescript generation tooling demands an export that matches the module name.
export const csvImportRemoteLookupSchema = z.any();

export const csvImportRemoteLookupIdSchema = common.objectId;

export const csvImportRemoteLookupItemSchema = z.object({
  id: common.objectId,
  name: z.string(),
  created_at: common.dateTime,
  import_is_done: z.boolean(),
  import_is_filterable: z.boolean(),
});

export const csvImportRemoteLookupFiltersSchema = z.object({});

export const csvImportRemoteLookupValidators = {
  id: csvImportRemoteLookupIdSchema,
  item: csvImportRemoteLookupItemSchema,
  filters: csvImportRemoteLookupFiltersSchema,
};

/* rails_test_output_hash: 598afc79f9a31f45af403bfd109db42a */
